import React from 'react';

/**
 * LE ICONE A LINEA DEL GUSCIO NOVA (barra in basso e pannelli del telefono):
 * un tratto solo, del colore del testo intorno, cosi' la voce accesa e quella
 * spenta cambiano colore insieme alla scritta. Le emoji cambiavano disegno da
 * un telefono all'altro e non seguivano i colori della skin.
 */
const TRATTI = {
  menu: <path d={'M4 6h16M4 12h16M4 18h16'}/>,
  strati: <path d={'m12 3 9 5-9 5-9-5zM3 13l9 5 9-5'}/>,
  home: <path d={'M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z'}/>,
  giochi: <><rect x={'3'} y={'3'} width={'18'} height={'18'} rx={'4'}/><circle cx={'8'} cy={'8'} r={'1.4'} fill={'currentColor'}/><circle cx={'12'} cy={'12'} r={'1.4'} fill={'currentColor'}/><circle cx={'16'} cy={'16'} r={'1.4'} fill={'currentColor'}/></>,
  live: <><rect x={'2'} y={'6'} width={'14'} height={'12'} rx={'2'}/><path d={'m16 10 6-4v12l-6-4'}/></>,
  razzo: <><path d={'M5 15c-1.5 1.3-2 5-2 5s3.7-.5 5-2M14 4c3-1.5 6-1 6-1s.5 3-1 6l-6 6-5-5z'}/><circle cx={'15'} cy={'9'} r={'1.5'}/></>,
  pallone: <><circle cx={'12'} cy={'12'} r={'9'}/><path d={'m12 7 4 3-1.5 5h-5L8 10z'}/></>,
  orologio: <><circle cx={'12'} cy={'13'} r={'8'}/><path d={'M12 9v4l2.5 2M10 2h4'}/></>,
  picche: <path d={'M12 3c3 4 7 6 7 10a4 4 0 0 1-7 2.5A4 4 0 0 1 5 13c0-4 4-6 7-10zM12 15v6M9 21h6'}/>,
  joystick: <><rect x={'2'} y={'7'} width={'20'} height={'11'} rx={'5'}/><path d={'M7 11v3M5.5 12.5h3'}/><circle cx={'16'} cy={'11.5'} r={'1'} fill={'currentColor'}/><circle cx={'18'} cy={'14'} r={'1'} fill={'currentColor'}/></>,
  utente: <><circle cx={'12'} cy={'8'} r={'4'}/><path d={'M4 21c0-4 4-6 8-6s8 2 8 6'}/></>,
  nuovoUtente: <><circle cx={'10'} cy={'8'} r={'4'}/><path d={'M2 21c0-4 4-6 8-6s8 2 8 6M19 6v6M16 9h6'}/></>,
  portafoglio: <><rect x={'3'} y={'6'} width={'18'} height={'13'} rx={'2.5'}/><path d={'M3 10h18'}/><circle cx={'16.5'} cy={'14.5'} r={'1.2'} fill={'currentColor'}/></>,
  piu: <path d={'M12 5v14M5 12h14'}/>,
  entra: <path d={'M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3'}/>,
  esci: <path d={'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9'}/>,
  tessera: <><rect x={'3'} y={'5'} width={'18'} height={'14'} rx={'2'}/><circle cx={'9'} cy={'11'} r={'2.2'}/><path d={'M6 16c.6-1.5 1.7-2.2 3-2.2s2.4.7 3 2.2M15 10h3M15 13h3'}/></>,
  grafico: <path d={'M4 20V10M10 20V4M16 20v-7M22 20H2'}/>,
  scontrino: <path d={'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6'}/>,
  lucchetto: <><rect x={'5'} y={'11'} width={'14'} height={'10'} rx={'2'}/><path d={'M8 11V7a4 4 0 0 1 8 0v4'}/></>,
  scudo: <path d={'M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z'}/>,
  rete: <><circle cx={'9'} cy={'8'} r={'3.5'}/><path d={'M2 20c0-3.5 3-5.5 7-5.5s7 2 7 5.5'}/><circle cx={'17'} cy={'9'} r={'2.5'}/><path d={'M17 14.5c3 0 5 1.8 5 4.5'}/></>,
  scambio: <path d={'M4 8h13l-3-3M20 16H7l3 3'}/>,
  rapporto: <><circle cx={'12'} cy={'12'} r={'9'}/><path d={'M12 3v9l6.5 4'}/></>,
  giu: <path d={'M12 4v12M6 11l6 6 6-6M5 20h14'}/>,
  su: <path d={'M12 20V8M6 13l6-6 6 6M5 4h14'}/>,
  slot: <><rect x={'3'} y={'4'} width={'18'} height={'16'} rx={'3'}/><path d={'M8 4v16M16 4v16'}/></>,
  tavolo: <><circle cx={'12'} cy={'12'} r={'8'}/><circle cx={'12'} cy={'12'} r={'3'}/></>,
  coppa: <path d={'M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0zM7 6H4a3 3 0 0 0 3 4M17 6h3a3 3 0 0 1-3 4'}/>,
  lente: <><circle cx={'11'} cy={'11'} r={'7'}/><path d={'m20 20-4-4'}/></>,
  punto: <circle cx={'12'} cy={'12'} r={'3'} fill={'currentColor'}/>,
  fumetto: <path d={'M4 5h16v11H9l-5 4z'}/>,
  occhio: <><path d={'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z'}/><circle cx={'12'} cy={'12'} r={'3'}/></>,
  occhioChiuso: <><path d={'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z'}/><circle cx={'12'} cy={'12'} r={'3'}/><path d={'M3 3l18 18'}/></>,
  x: <path d={'M6 6l12 12M18 6 6 18'}/>,
  /* I riquadri dei punti di forza nel piede (PiedeNova). */
  fulmine: <path d={'M13 2 4 14h7l-1 8 9-12h-7z'}/>,
  cuffie: <><path d={'M4 15v-3a8 8 0 0 1 16 0v3'}/><rect x={'3'} y={'14'} width={'4'} height={'7'} rx={'1.5'}/><rect x={'17'} y={'14'} width={'4'} height={'7'} rx={'1.5'}/></>,
  regalo: <><rect x={'3'} y={'8'} width={'18'} height={'5'} rx={'1'}/><path d={'M5 13v8h14v-8M12 8v13M12 8S10.5 3 8 4s-.5 4 4 4zM12 8s1.5-5 4-4 .5 4-4 4z'}/></>,
  stella: <path d={'m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9z'}/>,
  diamante: <path d={'M6 3h12l4 6-10 12L2 9zM2 9h20M9 3l3 6 3-6M12 9v12'}/>,
  ruota: <><circle cx={'12'} cy={'12'} r={'9'}/><circle cx={'12'} cy={'12'} r={'2'}/><path d={'M12 3v7M12 14v7M3 12h7M14 12h7M5.6 5.6l5 5M13.4 13.4l5 5M18.4 5.6l-5 5M10.6 13.4l-5 5'}/></>,
  corona: <path d={'M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5zM5 19h14'}/>,
  altro: <><circle cx={'5'} cy={'12'} r={'1.6'} fill={'currentColor'}/><circle cx={'12'} cy={'12'} r={'1.6'} fill={'currentColor'}/><circle cx={'19'} cy={'12'} r={'1.6'} fill={'currentColor'}/></>,
  moneta: <><circle cx={'12'} cy={'12'} r={'9'}/><path d={'M9.5 8h4a2 2 0 0 1 0 4h-4h4.5a2 2 0 0 1 0 4h-4.5zM11 6.5V8M11 16v1.5'}/></>,
  /* Le pagine di Aiuto (ICONA_AIUTO) e i canali di Assistenza. */
  palazzo: <path d={'M3 21h18M5 21V8l7-5 7 5v13M9 21v-5h6v5M9 11h.01M15 11h.01'}/>,
  documento: <><path d={'M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8z'}/><path d={'M14 3v5h5M9 13h6M9 17h6'}/></>,
  biscotto: <><path d={'M12 3a9 9 0 1 0 9 9 3 3 0 0 1-3.5-3A3 3 0 0 1 14 5.5 3 3 0 0 1 12 3z'}/><circle cx={'8.5'} cy={'10.5'} r={'1'} fill={'currentColor'}/><circle cx={'12'} cy={'15.5'} r={'1'} fill={'currentColor'}/><circle cx={'16'} cy={'13'} r={'1'} fill={'currentColor'}/></>,
  aereo: <path d={'M21 3 3 10.5l7 2.5 2.5 7zM21 3 10 13'}/>,
  busta: <><rect x={'3'} y={'5'} width={'18'} height={'14'} rx={'2'}/><path d={'m3 7 9 6 9-6'}/></>,
  domanda: <><circle cx={'12'} cy={'12'} r={'9'}/><path d={'M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6M12 17h.01'}/></>,
  info: <><circle cx={'12'} cy={'12'} r={'9'}/><path d={'M12 11v6M12 7.5h.01'}/></>,
  avviso: <path d={'M12 3 2 20h20zM12 10v4M12 17h.01'}/>,
};

/** L'icona di ogni pagina di Aiuto (le chiavi di pagineAiuto): sempre disegnate, mai emoji. */
export const ICONA_AIUTO = {
  chiSiamo: 'palazzo', regolamento: 'documento', assistenza: 'fumetto',
  terminiBonus: 'regalo', privacy: 'lucchetto', cookie: 'biscotto',
};

/**
 * Il disegno al posto dell'emoji che apre un riquadro nelle pagine di testo
 * («💬 CHAT IN ARRIVO»): le emoji piu' comuni hanno il loro, le altre il
 * cerchietto con la «i».
 */
const DA_EMOJI = {
  '💬': 'fumetto', '🗨': 'fumetto', '📞': 'cuffie', '🎧': 'cuffie', '✉': 'busta', '📧': 'busta', '📩': 'busta',
  '🛡': 'scudo', '🔒': 'lucchetto', '🔐': 'lucchetto', '🎁': 'regalo', '⭐': 'stella', '🌟': 'stella', '⚡': 'fulmine',
  '⚠': 'avviso', '❗': 'avviso', '🚫': 'avviso', '❓': 'domanda', '❔': 'domanda', 'ℹ': 'info',
  '💳': 'portafoglio', '💰': 'moneta', '🪙': 'moneta', '⏱': 'orologio', '⏰': 'orologio', '🕘': 'orologio',
  '🏆': 'coppa', '📜': 'documento', '📄': 'documento', '📋': 'documento', '🏢': 'palazzo', '🍪': 'biscotto',
  '👤': 'utente', '👥': 'rete', '🔍': 'lente', '🚀': 'razzo', '🎰': 'slot', '✈': 'aereo',
};
export function iconaDaEmoji(emoji) {
  return DA_EMOJI[String(emoji || '').replace(/[\uFE0F\u200D]/g, '')] || 'info';
}

/** L'icona di ogni pagina del modulo Pagine (le chiavi di pagineDelMenu): sempre disegnate, mai emoji. */
export const ICONA_PAGINA = {
  promozioni: 'regalo', tornei: 'coppa', vip: 'diamante', fedelta: 'stella', ruota: 'ruota', hallOfFame: 'corona',
};

/** L'icona delle sezioni del catalogo (le chiavi di sezioniAccese). */
export const ICONA_SEZIONE = {
  sport: 'pallone', liveSport: 'orologio', sportBetby: 'pallone', casino: 'giochi', liveCasino: 'live',
  poker: 'picche', virtual: 'joystick', crashGame: 'razzo',
};

export default function IconaNova({nome, misura = 22}) {
  return (
    <svg width={misura} height={misura} viewBox={'0 0 24 24'} fill={'none'} stroke={'currentColor'} strokeWidth={'1.9'}
      strokeLinecap={'round'} strokeLinejoin={'round'} aria-hidden={'true'} focusable={'false'}>
      {TRATTI[nome] || TRATTI.punto}
    </svg>
  );
}
